'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _immutable = require('react-redux-form/immutable');

var _bisuReactFormError = require('bisu-react-form-error');

var _bisuReactFormError2 = _interopRequireDefault(_bisuReactFormError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BisuReactInput = function (_Component) {
  _inherits(BisuReactInput, _Component);

  function BisuReactInput() {
    _classCallCheck(this, BisuReactInput);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  BisuReactInput.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.props.autoFocus) {
      setTimeout(function () {
        _this2._input.select();
      }, 10);
    }
  };

  BisuReactInput.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        model = _props.model,
        type = _props.type,
        label = _props.label,
        required = _props.required,
        props = _objectWithoutProperties(_props, ['model', 'type', 'label', 'required']);

    return _react2.default.createElement(
      _immutable.Field,
      { model: model, className: 'bisu--react-input' },
      _react2.default.createElement(
        'label',
        { htmlFor: model },
        label,
        ' ',
        required && _react2.default.createElement(
          'span',
          { className: 'req' },
          '*'
        )
      ),
      _react2.default.createElement('input', _extends({
        type: type,
        className: 'form-control',
        ref: function ref(c) {
          return _this3._input = c;
        }
      }, props)),
      (0, _bisuReactFormError2.default)(model)
    );
  };

  return BisuReactInput;
}(_react.Component);

process.env.NODE_ENV !== "production" ? BisuReactInput.propTypes = {
  model: _propTypes.string,
  type: _propTypes.string,
  label: _propTypes.any,
  required: _propTypes.bool
} : void 0;

BisuReactInput.defaultProps = {
  type: 'text'
};

exports.default = BisuReactInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bisu-react-input/lib/index.js
// module id = 474
// module chunks = 0